// WHAT: Page-Komponente als Einbindungspunkt für den `OuraDashboard`-Organism in das Routing-System
// WHY:  Trennt Routing-/Page-Layer von der eigentlichen Dashboard-Logik und folgt der Page-Konvention der Domains
// DOMAIN: health → oura → pages
// DEPENDENCIES: `OuraDashboard`-Organism
// RISKS:
//   - NOTE: Zusätzliche Layout-/Provider-Anpassungen sollten über höherliegende Layout-Komponenten erfolgen, nicht hier
import React from "react";

import { OuraDashboard } from "../organisms/OuraDashboard";

export const OuraDashboardPage: React.FC = () => {
  return <OuraDashboard />;
};
